export default {
  heading: {
    widgetName: "Shopping Product Widget",
    widgetID: "107",
    cardCount: "5",
    headlineType: "h2",
    widgetWidth: '3',
    layoutName: "lob_widget",
    headline: "SHOP Favourites",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `shop | SHOP Favourites`,
      eventLabelCardClick: `shop | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `shop | headline | {{headline}}`,
      eventLabelView: `shop | SHOP Favourites`,
    },
  },

	data: [{
			cta: 'Masukkan Keranjang',
			currencyCode: 'MYR',
			discount: '',
			formattedOriginalPriceMob: 'IDR 70.000',
			formattedOriginalPriceWeb: 'IDR 70.000',
			formattedPriceMob: 'IDR 55.000',
			formattedPriceWeb: 'IDR 55.000',
			hidden: '',
			image: 'https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blt8bcd5c0e672a35cd/63525b165412c947d010274c/jpg_1666341653540.jpg',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Old Town White Coffee 3 in 1',
			title: 'Old Town',
			url: 'https://www.airasia.com/shop/id/id/product/old-town-white-coffee/oldtown-white-coffee-3in1-classic?type_id=2'
		},
		{
			cta: 'Masukkan Keranjang',
			currencyCode: 'MYR',
			discount: '',
			formattedOriginalPriceMob: 'IDR 1.100.000',
			formattedOriginalPriceWeb: 'IDR 1.100.000',
			formattedPriceMob: 'IDR 600.000',
			formattedPriceWeb: 'IDR 600.000',
			hidden: '',
			image: 'https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/bltff0bbe6f93200ff9/63d374437630d31632092079/aigner-clear-day-men-ml-jpg_1674802243132.jpg',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Aigner Clear Day Men',
			title: 'Aigner',
			url: 'https://www.airasia.com/shop/id/id/product/auraluxe/aigner-clear-day-men-100ml?type_id=1'
		},
		{
			cta: 'Masukkan Keranjang',
			currencyCode: 'MYR',
			discount: '',
			formattedOriginalPriceMob: 'IDR 19.500',
			formattedOriginalPriceWeb: 'IDR 19.500',
			formattedPriceMob: 'IDR 19.500',
			formattedPriceWeb: 'IDR 19.500',
			hidden: '',
			image: 'https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blted507abae3a64baf/62cbf89c267bd810da2fbe63/breyleeacnepimplepatchmmjpgjpg_1657534619599.jpg',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: '[BPOM] BREYLEE Acne Pimple Patch Day - Penghilang & Stiker Jerawat 0.1 mm (22 stiker)',
			title: 'BREYLEE',
			url: 'https://www.airasia.com/shop/id/id/product/breylee/bpom-breylee-acne-pimple-patch-day-penghilang-stiker-jerawat-01-mm-22-stiker?type_id=1'
		},
		{
			cta: 'Masukkan Keranjang',
			currencyCode: 'MYR',
			discount: '',
			formattedOriginalPriceMob: 'IDR 210.000',
			formattedOriginalPriceWeb: 'IDR 210.000',
			formattedPriceMob: 'IDR 200.000',
			formattedPriceWeb: 'IDR 200.000',
			hidden: '',
			image: 'https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blt9d47f0468f340116/62c0731810d1fc7f50ee8d08/airasiacomfortkitredjpgjpg_1656779543733.jpg',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Comfort Kit Red',
			title: 'airasia Merchandise',
			url: 'https://www.airasia.com/shop/id/id/product/airasia-merchandise-id/comfort-kit-red?type_id=2'
		},
		{
			cta: 'Masukkan Keranjang',
			currencyCode: 'MYR',
			discount: '',
			formattedOriginalPriceMob: 'IDR 389.000',
			formattedOriginalPriceWeb: 'IDR 389.000',
			formattedPriceMob: 'IDR 377.330',
			formattedPriceWeb: 'IDR 377.330',
			hidden: '',
			image: 'https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blt676e1c6180da6bdc/63184e0b016f5c37783abb04/jpgjpg_1662537226839.jpg',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'Balans Pure Unflavored Collagen Drink - 14 sachet',
			title: 'Balans Official',
			url: 'https://www.airasia.com/shop/id/id/product/balans-official/balans-pure-unflavored-collagen-drink-14-sachet?type_id=1'
		}
	]
}